<template>
    <AppLayout>
        <ProductsLayout :products="products" :categories="categories" :sort-options="sortOptions">
            <template #content>
                <div class="bg-white">
                    <div class="mx-auto max-w-2xl py-6 lg:max-w-7xl">
                        <h2 class="sr-only">Products</h2>
                        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 lg:grid-cols-3">
                            <a v-for="product in products" :key="product.id" :href="`/courses/${product.slug}`"
                                class="group border border-[#E5E5E5] hover:border-[#A07830] transition-colors duration-200">
                                <div class="overflow-hidden h-52 bg-[#F5F5F5]">
                                    <img :src="product.image" :alt="product.imageAlt"
                                        class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                                </div>
                                <div class="p-4">
                                    <span class="text-xs font-semibold uppercase tracking-widest text-[#A07830]">Course</span>
                                    <h3 class="mt-1 text-sm font-bold text-[#17364a]">{{ product.name }}</h3>
                                    <div class="mt-3 flex items-center justify-between">
                                        <span class="text-xs text-gray-400">Nobel Academy</span>
                                        <span class="text-xs font-semibold text-[#A07830]">View &rarr;</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </template>
        </ProductsLayout>
    </AppLayout>
</template>

<script setup>

import AppLayout from '@/components/layouts/AppLayout.vue';
import ProductsLayout from '@/components/layouts/ProductsLayout.vue';

const props = defineProps({
    products: {
        type: Array,
        default: () => []
    }
});

import { ref, watchEffect } from 'vue'
import { onMounted } from 'vue';
import { getCategories } from '@/services/categoryService';
import { getProducts } from '@/services/productService';
import { useRouter } from 'vue-router';

const router = useRouter();
const categories = ref([]);
const products = ref([]);
const sortOptions = [
    { name: 'Most Popular', href: '#', current: true },
    { name: 'Best Rating', href: '#', current: false },
    { name: 'Newest', href: '#', current: false },
]

const query = router.currentRoute.value.query;

const fetchCategories = async () => {
    await getCategories()
        .then(data => {
            categories.value = data.data.map(category => {
                return {
                    name: category.name,
                    href: `/courses?category=${category.slug}`,
                }
            });
        })
        .catch(error => {
            // console.error('Error fetching categories:', error);
        });
}

const fetchProducts = async () => {
    await getProducts()
        .then(data => {
            products.value = data.data;
            console.log('Fetched Products:', data.data);
        })
        .catch(error => {
            // console.error('Error fetching products:', error);
        });
}


onMounted(() => {
    fetchCategories();
    fetchProducts();
});

watchEffect(() => {
    if (query.category) {
        products.value = products.value.filter(product => {
            return product.category && product.category.slug === query.category;
        });
    }
});

const mobileFiltersOpen = ref(false)

</script>
